"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const React = __importStar(require("react"));
const utils_1 = require("../utils"); // Utility function for conditional class names.
const Checkbox = React.forwardRef(({ className, ...props }, ref) => {
    return (React.createElement("input", { className: (0, utils_1.cn)("cursor-pointer h-[18px] w-[18px] border-none appearance-none relative before:content-[''] before:absolute before:top-0 before:left-0 before:border-solid before:rounded-[2px] before:border-2 before:border-brandBlack before:w-full before:h-full checked:before:bg-neutral-900 checked:after:content-[''] checked:after:w-[10px] checked:after:bg-brandBlack after:h-[5px] after:top-[6px] after:text-sm after:absolute after:-left-[1px] after:translate-x-1/2 after:text-brandWhite checked:after:border-l-2 after:border-l-solid after:border-l-brandWhite checked:after:border-b-2 after:border-b-solid after:border-b-brandWhite after:transform after:rotate-[-45deg]", className), ref: ref, type: "checkbox", ...props }));
});
exports.Checkbox = Checkbox;
Checkbox.displayName = "Checkbox";
